import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'sonner';

function AadharDetails({ data, AadharApi }) {
  const [otp, setOtp] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (data?.data?.referenceId) {
      setSubmitted(false);
    }
  }, [data]);
  const handleOtpSubmit = async () => {
    // Optional: validate OTP length
    if (!otp) return toast.error('OTP cannot be empty');
    if (!mobileNumber) return toast.error('Mobile Number cannot be empty');
    const requestBody = {
      apiId: '6807546caf033a39cd7c6fe8',
      documentData: {
        referenceId: data?.data?.referenceId,
        otp: otp,
        consent: 'Y',
        mobileNumber: mobileNumber,
      },
    };
    setIsLoading(true);

    try {
      AadharApi({
        documentType: 'AADHAAR_DETAILED_VERIFY_OTP',
        body: requestBody,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
      setSubmitted(true);
      setMobileNumber('');
      setOtp('');
    }
  };
  return (
    <div className="flex flex-col gap-4">
      {!submitted ? (
        <>
          <Input
            type="text"
            value={data?.data?.referenceId}
            placeholder="Reference Number"
            className="border p-2 rounded text-sm"
            disabled
          />
          <Input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            className="border p-2 rounded text-sm"
          />
          <Input
            type="text"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="Mobile Number"
            className="border p-2 rounded text-sm"
          />

          <Button onClick={handleOtpSubmit} loading={isLoading}>
            Submit OTP
          </Button>
        </>
      ) : (
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="mb-6 border-b pb-4">
            <h3 className="text-xl font-semibold text-primary">
              UIDAI verified Offline Aadhaar e-KYC
            </h3>
            <p className="text-sm text-muted-foreground">
              This document is generated from verified Offline Aadhaar XML
              obtained from UIDAI with due user consent and authentication.
            </p>
          </div>

          {/* Main Content */}
          <div className="space-y-6">
            {/* Basic Document Information */}
            <table className="w-full border-collapse">
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background w-1/3">
                    Document type
                  </td>
                  <td className="py-2 px-4">
                    Offline Aadhaar e-KYC document generated from UIDAI verified
                    Aadhaar XML.
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Generation date
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.generatedAt
                      ? new Date(
                          parseInt(data.data.generatedAt),
                        ).toLocaleString()
                      : new Date().toLocaleString()}
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Reference ID
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.referenceId || 'N/A'}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Personal Information */}
            <table className="w-full border-collapse">
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background w-1/3">
                    Masked Aadhaar number
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.maskedNumber || 'N/A'}
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">Name</td>
                  <td className="py-2 px-4">{data?.data?.name || 'N/A'}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Date of Birth
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.dateOfBirth || 'N/A'}
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Gender
                  </td>
                  <td className="py-2 px-4">{data?.data?.gender || 'N/A'}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">Email</td>
                  <td className="py-2 px-4">{data?.data?.email || 'N/A'}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Hashed Phone
                  </td>
                  <td className="py-2 px-4">{data?.data?.phone || 'N/A'}</td>
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background">
                    Aadhaar Linked Mobile
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.aadhaar_linked_mobile_match || 'N/A'}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Address Information */}
            <table className="w-full border-collapse">
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-4 font-medium bg-background w-1/3">
                    C/O, S/O
                  </td>
                  <td className="py-2 px-4">
                    {data?.data?.address?.careOf || 'N/A'}
                  </td>
                </tr>
                <tr className="border-b">
                  <td
                    className="py-2 px-4 font-medium bg-background"
                    rowSpan="1"
                  >
                    Address
                  </td>
                  <td className="py-2 px-4">
                    {[
                      data?.data?.address?.careOf,
                      data?.data?.address?.house,
                      data?.data?.address?.landmark,
                      data?.data?.address?.locality,
                      data?.data?.address?.vtc,
                      data?.data?.address?.district,
                      data?.data?.address?.state,
                      data?.data?.address?.country,
                      data?.data?.address?.pin,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Photo and PDF Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Photo Section */}
              {data?.data?.photo && (
                <div className="border rounded-md overflow-hidden">
                  <div className="bg-background py-2 px-4 font-medium">
                    Photo
                  </div>
                  <div className="p-4 flex justify-center">
                    <img
                      src={`data:image/jpeg;base64,${data.data.photo}`}
                      alt="Aadhaar Photo"
                      className="w-32 h-32 object-cover"
                    />
                  </div>
                </div>
              )}

              {/* Document PDF Download */}
              {/* {data?.data?.document_pdf && (
                    <div className="border rounded-md overflow-hidden">
                      <div className="bg-background py-2 px-4 font-medium">
                        Document PDF
                      </div>
                      <div className="p-4 flex justify-center">
                        <a
                          href={`data:application/pdf;base64,${data.data.document_pdf}`}
                          download="aadhaar_document.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors flex items-center"
                        >
                          <span className="mr-2">Download PDF</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line
                              x1="12"
                              y1="15"
                              x2="12"
                              y2="3"
                            ></line>
                          </svg>
                        </a>
                      </div>
                    </div>
                  )} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AadharDetails;
